import type { TRequestErrorDetail } from './errors.types.ts';

export const describeDetail = (detail: TRequestErrorDetail): string => {
  if (detail.kind === 'server') {
    return detail.body?.message ?? `HTTP ${detail.status}`;
  }

  if (detail.kind === 'refused') {
    return detail.reason ?? detail.kind;
  }

  return detail.kind;
};
